'use strict';

exports.__esModule = true;
exports.members = exports.contacts = undefined;

var _crmWixcodeJsCommons = require('crm-wixcode-js-commons');

exports.contacts = _crmWixcodeJsCommons.contacts;
exports.members = _crmWixcodeJsCommons.members;
//# sourceMappingURL=platformizedEndpointsUtils.js.map